import React, {useState, useRef, forwardRef, useEffect, useCallback, useContext} from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import {dateToCalendar, useInterval, strArraySortAsc, showToast, updateUTCDate} from '../common/app_common.js';
import {getApiSystemStatus} from '../common/fetch_api/api_common.js';
import {getApiSitesCount, getApiSites, getApiSitesSite, getApiSitesKeyword} from '../common/fetch_api/site.js';
import {getApiEdgeId} from '../common/fetch_api/edge.js';
import {CalendarSeletor} from '../common/modal_common.js';
import {getApiDataQuery} from '../common/fetch_api/data';
import {checkApiDataResult} from '../pages/sites_list/monitoring/monitoring_common.js';
import Button from 'react-bootstrap/Button';
import { BsJustify, BsSearch, BsChevronBarLeft, BsChevronLeft, BsChevronBarRight, BsChevronRight, BsArrowClockwise, BsDisplay } from 'react-icons/bs';
import {useNavigate} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css'; // 기본 스타일
import { use } from 'react';

export const Title = ({title}) => {

    const [contents, setContents] = useState(null);

    useEffect( () => {
        setContents( 
            <div className="d-flex">
                <Button variant="primary" className="sidebarCollapse" onClick={sidebarCollapse}>
                    <BsJustify></BsJustify>
                </Button>
                <div className="page-title">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">{title}</li>
                    </ul>
                </div>
            </div>
        );
    }, [title] );

    return (
        <>
            {contents}
        </>
    );
};

export const TitleDetail = ({siteName, edgeTitle, setPageName}) => {

    const goBackToSiteList = () =>
    {
        setPageName('siteList');
    }

    const goBackToSiteDetail = () =>
    {
        setPageName('siteDetail');
    }

    return (
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="d-flex">
                <Button variant="primary" className="sidebarCollapse" onClick={sidebarCollapse}>
                    <BsJustify></BsJustify>
                </Button>
                <div className="page-title">
                    <ul className="breadcrumb">
                        <li className={`breadcrumb-item ${siteName ? 'pointer' : ''}`} onClick={goBackToSiteList}>Sites List</li>
                        {siteName && <li className={`breadcrumb-item ${edgeTitle ? 'pointer' : 'active'}`} onClick={goBackToSiteDetail}>{siteName}</li>}
                        {edgeTitle && <li className='breadcrumb-item active'>{edgeTitle}</li>}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export const TermRefresh = ({setTerm, term, setRefresh, refresh, setIsStop, isStop, reload, setReload, setIsCalendar, isCalendar}) =>
{
    const termOptions = [
        {value: "1", label: 'Last 1 minutes'},
        {value: "5", label: 'Last 5 minutes'},
        {value: "15", label: 'Last 15 minutes'},
        {value: "30", label: 'Last 30 minutes'},
        {value: "60", label: 'Last 1 hour'},
        {value: "180", label: 'Last 3 hour'},
        {value: "360", label: 'Last 6 hour'},
        {value: "720", label: 'Last 12 hour'},
        {value: "1440", label: 'Last 24 hour'},
        {value:'calendar', label: 'Calendar'}
    ];

    const refreshOptions = [
        {value: 5000, label: '5 sec'},
        {value: 10000, label: '10 sec'},
        {value: 30000, label: '30 sec'},
        {value: 60000, label: '1 min'},
        {value: 600000, label: '10 min'},
        {value: 1800000, label: '30 min'},
        {value: 'stop', label: 'stop'},
    ];

    const [disabledBtn, setDisabledBtn]  = useState(false);

    const [startTime, setStartTime] = useState(new Date());
    const [endTime, setEndTime] = useState(new Date());

    const onChangeTerm = e =>
    {
        if(e.target.value === 'calendar')
        {
            setIsStop(true);
            setIsCalendar(true);

            const now = new Date();
            //현재 시간과, 1시간 전 시간을 표시
            setStartTime( new Date(now.getTime() - 3600000) );
            setEndTime(now);
        }
        else
        {
            setIsStop(false);
            setIsCalendar(false);
            setTerm(e.target.value);
        }
    }

    const onChangeRefresh = e =>
    {
        if(e.target.value === 'stop')
        {
            setDisabledBtn(true);
            setIsStop(true);
        }
        else
        {
            setDisabledBtn(false);
            setIsStop(false);
            setRefresh(+e.target.value);
        }
    }

    const queryCalendar = ()=>
    {
        let start = startTime.getTime() / 1000;
        let end = endTime.getTime() / 1000;

        let timePeriod  = end - start;
        let term = Math.floor(timePeriod / 60);
        
        setTerm(term);
    }

    // const onChangeFrom = (e) =>
    // {
    //     setStartTime(e.target.value);
    // }

    // const onChangeTo = (e) =>
    // {
    //     setEndTime(e.target.value);
    // }

    const onClickReload = () =>
    {
        setReload(!reload);
    }

    return (
        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 term-refresh-area">
            <div className="d-flex flex-wrap justify-content-end">
                <div className="d-flex">
                    <div className="select-menu">
                        <select className="form-select form-select-sm" onChange={onChangeTerm} value={isCalendar ? 'calendar' : term}>
                            {termOptions.map((item, index) => (
                                    <option key={index} value={item.value}>{item.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="refreshQuery">
                        <div className="input-group input-group-sm flex-nowrap">
                            <label className="input-group-text">Refresh</label>
                            <select className="form-select" onChange={onChangeRefresh} value={isStop ? 'stop' : refresh}>
                                {refreshOptions.map((item, index) => (
                                        <option key={index} value={item.value}>{item.label}</option>
                                ))}
                            </select>
                            <button type="button" className="btn btn-primary btn-sm refresh-btn" disabled={disabledBtn} onClick={onClickReload}><BsArrowClockwise /></button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12">
                {isCalendar && <div className="d-flex flex-wrap justify-content-end search-by-date">
                    <div className="d-flex firstCol">
                        <span className="space-text"> From </span>
                        {/* <input type="datetime-local" id="startTime" className="input-date" value={startTime} onChange={onChangeFrom}></input> */}
                        <CommonDatePicker domId='startTime' domClass="input-date" state={startTime} setState={setStartTime} domDisable={false}/>
                    </div>
                    <div className="d-flex secondCol">
                        <span className="space-text"> To </span>
                        {/* <input type="datetime-local" id="endTime" className="input-date" value={endTime} onChange={onChangeTo}></input> */}
                        <CommonDatePicker domId='endTime' domClass="input-date" state={endTime} setState={setEndTime} domDisable={false}/>
                        <button type="button" className="btn btn-primary btn-sm" onClick={queryCalendar}><BsSearch /></button>
                    </div>
                </div>}
            </div>
        </div>
    )
}

const sidebarCollapse = () => {
    document.getElementById('sidebar').classList.toggle('active');
};

export const TopSitesAlertStatusSection = ({searchName, setSearchName, searchType, setSearchType, sitesSeveriry, selectSiteSeverity, active}) =>
{
    const [searchList, setSearchList] = useState([]);
    
    const [selectDisabled, setSelectDisabled] = useState(true);

    const [severityCount, setSeverityCount] = useState({total:0, good:0, warning:0, critical:0});
    
    useEffect(() =>
    {
        let filteredSites = [];
        let goodArr = [];
        let warningArr = [];
        let criticalArr = [];

        if( Array.isArray(sitesSeveriry) )
        {
            if(searchType === 'callsign')
            {
                filteredSites = [...sitesSeveriry].filter(e => e.site === searchName);
                goodArr = filteredSites.filter(e => e.severity ==='good');
                warningArr = filteredSites.filter(e => e.severity ==='warning');
                criticalArr = filteredSites.filter(e => e.severity ==='critical');
                setSeverityCount({total: filteredSites.length, good: goodArr.length, warning: warningArr.length, critical: criticalArr.length});
            }
            else if(searchType === 'market')
            {
                const searchNameCur = `${searchName===undefined?'':searchName}`;

                Promise.resolve( getApiSitesCount(searchNameCur, '') )
                .then( data => 
                {
                    if(data.count)
                    {
                        Promise.resolve( getApiSites(data.count, 1, searchNameCur, '', '', ''))
                        .then( data => 
                        {
                            if (!Array.isArray(data)) return;
                            filteredSites = [...data];
                            goodArr = filteredSites.filter(e => e.alertStatus ==='good');
                            warningArr = filteredSites.filter(e => e.alertStatus ==='warning');
                            criticalArr = filteredSites.filter(e => e.alertStatus ==='critical');
                            setSeverityCount({total: filteredSites.length, good: goodArr.length, warning: warningArr.length, critical: criticalArr.length});
                        })
                    }
                })
            }
            else
            {
                filteredSites = [...sitesSeveriry];
                goodArr = filteredSites.filter(e => e.severity ==='good');
                warningArr = filteredSites.filter(e => e.severity ==='warning');
                criticalArr = filteredSites.filter(e => e.severity ==='critical');
                setSeverityCount({total: filteredSites.length, good: goodArr.length, warning: warningArr.length, critical: criticalArr.length});
            }
        }
    },[sitesSeveriry, searchName, searchType])
    
        
    const searchOptionSelect = (e) =>
    {
        setSearchType(e.target.value);
        
        Promise.resolve( getApiSitesKeyword() )
        .then( data =>
        {
            if (!data) return;
            if(e.target.value === 'callsign')
            {
                const list = data.callsign || [];
                list.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));
                setSearchList(list);
                setSelectDisabled(false);
                setSearchName(list[0] ?? '');
            }
            else if(e.target.value === 'market')
            {
                const list = data.market || [];
                list.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));
                setSearchList(list);
                setSelectDisabled(false);
                setSearchName(list[0] ?? '');
            }
            else
            {
                let arr = [...(data.callsign || []), ...(data.market || [])];
                arr.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));
                setSearchList(arr);
                setSelectDisabled(true);
                setSearchName('');
            }
        });
    }

    const searchNameSelect = (e) =>
    {
        setSearchName(e.target.value);
    }

    useEffect(() =>
    {
        Promise.resolve( getApiSitesKeyword() )
        .then( data =>
        {
            if (!data) return;
            //첫 초기 all 인 상태를 만들어줌
            let arr = [...(data.callsign || []), ...(data.market || [])];
            arr.sort((a, b) => strArraySortAsc(a.toLowerCase(), b.toLowerCase()));
            setSearchList(arr);
        });
    } ,[])

    const getSeverity = (status) =>
    {
        selectSiteSeverity(status)
    }

    const [selectTitle, setSelectTitle] = useState('Total Station');
    
    const [update, setUpdate] = useState(false);

    const [systemSeverity, setSystemSeverity] = useState('');
    const [systemDetail, setSystemDetail] = useState(null);

    const [showDetailStatus, setShowDetailStatus] = useState(false);
    const openDetailStatus = () => {setShowDetailStatus(true)};
    const closeDetailStatus = () => {setShowDetailStatus(false)};

    const getServerStatus = () =>
    {
        Promise.resolve( getApiSystemStatus() )
        .then( data =>
        {
            if (!data) return;
            setSystemSeverity(data.systemSeverity ?? '');
            setSystemDetail(data);
        })
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        getServerStatus();
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, 10000 );

    return (
        <>
            <TopStatusSection active={active} selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Total Station'} status={'text-good'} value={severityCount.total} severity='' getSeverity={getSeverity}/>
            <TopStatusSection active={active} selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Good'} status={'text-good'} value={severityCount.good} severity='good' getSeverity={getSeverity}/>
            <TopStatusSection active={active} selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Warning'} status={'text-warning'} value={severityCount.warning} severity='warning' getSeverity={getSeverity}/>
            <TopStatusSection active={active} selectTitle={selectTitle} setSelectTitle={setSelectTitle} title={'Critical'} status={'text-critical'} value={severityCount.critical} severity='critical' getSeverity={getSeverity}/>            
            <div className="col-xxl-3 col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
                <div className="section d-flex flex-column section-search">
                    <div className="status-title">Filter</div>
                    <div className="d-flex search-select">
                        <div className="col-6 pe-3">
                            <select className="form-select form-select-sm" onChange={searchOptionSelect} value={searchType} disabled={!active}>
                                <option value="">All</option>
                                <option value="callsign">Callsign</option>
                                <option value="market">Market</option>
                            </select>
                        </div>
                        <div className="col-6">
                            <select className="form-select form-select-sm" value={searchName} onChange={searchNameSelect} disabled={selectDisabled || searchList.length < 1}>
                                {searchName && searchList.map((item, index)=>(
                                    <option key={index} value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-12 col-12 status-spacer"></div>
            <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6 position-relative">
                {/* <div className="section status d-flex flex-column flex-wrap" onMouseEnter={openDetailStatus} onMouseLeave={closeDetailStatus} > */}
                <div className="section status d-flex flex-column flex-wrap" onClick={() => {setShowDetailStatus(!showDetailStatus)}} >
                    <div className="status-title">Server Status</div>
                    <div className={`status-value text-${systemSeverity}`}>{(systemSeverity || '').replace(/\b[a-z]/g, char => char.toUpperCase())}</div>
                </div>
                <div className={`server-status-detail ${showDetailStatus?'':'d-none'}`}>
                    <DetailStatus detailData={systemDetail}/>
                </div>
            </div>
        </>
    )
}

const DetailStatus = ({detailData}) => {

    const [cpuUsage, setCpuUsage] = useState(0);
    const [memUsage, setMemUsage] = useState(0);
    const [diskUsage, setDiskUsage] = useState(0);
    const [DockerService, setDockerService] = useState(false);
    const [systemSeverity, setSystemSeverity] = useState([]);

    useEffect( () => {        
        if( detailData && detailData.hasOwnProperty('systemStats') )
        {
            if( detailData.systemStats.hasOwnProperty('cpu') && detailData.systemStats.cpu.hasOwnProperty('usage') )
            {
                setCpuUsage(parseInt(detailData.systemStats.cpu.usage));
            }
            else
            {
                setCpuUsage(0);
            }

            if( detailData.systemStats.hasOwnProperty('mem') && detailData.systemStats.mem.hasOwnProperty('usage') )
            {
                setMemUsage(parseInt(detailData.systemStats.mem.usage));
            }
            else
            {
                setMemUsage(0);
            }

            if( detailData.systemStats.hasOwnProperty('disk') )
            {
                const index = detailData.systemStats.disk.findIndex(item => item.path === '/');
                if( detailData.systemStats.disk[index].hasOwnProperty('usage') )
                {
                    setDiskUsage(parseInt(detailData.systemStats.disk[index].usage));
                }
                else
                {
                    setDiskUsage(0);
                }
            }
            else
            {
                setDiskUsage(0);
            }
        }
        else
        {
            setCpuUsage(0);
            setMemUsage(0);
            setDiskUsage(0);
        }
        
        if( detailData && detailData.hasOwnProperty('containerStats') )
        {
            if( detailData.containerStats )
            {
                let allOnes = true;

                for (let key in detailData.containerStats) {
                    if (detailData.containerStats.hasOwnProperty(key) && detailData.containerStats[key].healthy !== 1) {
                        allOnes = false;
                        break;
                    }
                }

                setDockerService(allOnes);
            }
            else
            {
                setDockerService(false);
            }
        }
        else
        {
            setDockerService(false);
        }
        
        if( detailData && detailData.hasOwnProperty('systemSeverity') )
        {
            setSystemSeverity(detailData.systemSeverity);
        }
        else
        {
            setSystemSeverity([]);
        }

    }, [detailData]);

    return (
        <div className="section status d-flex flex-column flex-wrap">
            <div className={`d-flex justify-content-between ${systemSeverity.indexOf('cpu') !== -1?'text-warning':''}`}>
                <div className="label lg">CPU Usage</div>
                <div className="label lg">{`${cpuUsage}%`}</div>
            </div>
            <div className={`d-flex justify-content-between ${systemSeverity.indexOf('mem') !== -1?'text-warning':''}`}>
                <div className="label lg">MEM Usage</div>
                <div className="label lg">{`${memUsage}%`}</div>
            </div>
            <div className={`d-flex justify-content-between ${systemSeverity.indexOf('disk') !== -1?'text-warning':''}`}>
                <div className="label lg">DISK Usage</div>
                <div className="label lg">{`${diskUsage}%`}</div>
            </div>
            <div className={`d-flex justify-content-between ${systemSeverity.indexOf('docker') !== -1?'text-warning':''}`}>
                <div className="label lg">Docker Service</div>
                <div className="label lg">{`${DockerService?'Good':'Warning'}`}</div>
            </div>
        </div>
    )
}

const TopStatusSection = ({active, selectTitle, setSelectTitle , title, status, value, severity, getSeverity}) => {

    const onClickSeverity = () =>
    {
        if( !active ) return;

        if( selectTitle !== title )
        {
            getSeverity(severity);
            setSelectTitle(title);
        }
    }

    return (
        <div className="col-xxl col-xl-2 col-lg-4 col-md-4 col-sm-6 col-6">
            <div className={`section status severity d-flex flex-column ${selectTitle === title ? 'active' : ''}`}  onClick={onClickSeverity}>
                <div className="status-title">{title}</div>
                <div className={`status-value ${status}`}>{value}</div>
            </div>
        </div>
    )
}

export const LoadingSpinner = ({loading}) => {
    
    const [result, setResult] = useState(null);

    useEffect( () => {
        if( loading )
        {
            setResult(
                <div className="loading-spinner"></div>
            );
        }
        else
        {
            setResult(<></>);
        }
    }, [loading] );

    return (
        <>
            {result}
        </>
    );
}

export const PageNation = forwardRef((props, ref) => {

    const movePage = (action) => {
        let maxPage = Math.ceil(props.selCount/props.pagePer);
        let refValue = parseInt(ref.current.value);

        let movePage;
        if( action === 'first' ) {
            if( props.curPageState <= 1 ) {
                return;
            }    
            movePage = 1;
        } else if( action === 'last' ) {
            if( props.curPageState >= maxPage ) {
                return;
            }    
            movePage = maxPage;
        } else if( action === 'pre' ) {
            if( props.curPageState <= 1 ) {
                return;
            }            
            movePage =  props.curPageState - 1;
        } else if( action === 'next' ) {        
            if( props.curPageState >= maxPage ) {
                return;
            }            
            movePage = props.curPageState + 1;
        } else if( action === 'input' ) {
            if( refValue > maxPage ) {
                movePage = maxPage;
            } else if( refValue <= 0 ) {
                movePage = 1;
            } else {
                movePage = refValue;
            }        
        } else {
            return;
        }
        
        props.setCurPageState(movePage);
        ref.current.value = movePage;
    }

    return (
        <div className="pagination">
            <BsChevronBarLeft onClick={() => {
                movePage('first');
            }}></BsChevronBarLeft>
            <BsChevronLeft className='mx-2' onClick={() => {
                movePage('pre');
            }}></BsChevronLeft>
            <input type="number" className="input-page" ref={ref} onChange={() => {
                movePage('input');
            }}/>
            <span>{` / ${Math.ceil(props.selCount/props.pagePer)}`}</span>
            <BsChevronRight className='mx-2' onClick={() => {
                movePage('next');
            }}></BsChevronRight>
            <BsChevronBarRight onClick={() => {
                movePage('last');
            }}></BsChevronBarRight>
        </div>
    )
});

export const SeletorWithCalendar = ({result, label, opt, setOpt, val, setVal}) =>
{

    const [optList, setOptList] = useState(null);
    const [update, setUpdate] = useState(false);

    const [modalCalendar, setModalCalendar] = useState(false);
    const showModalCalendar = () => setModalCalendar(true);
    const closeModalCalendar = () => setModalCalendar(false);

    const onChangeSelector = e =>
    {
        if(e.target.value === 'calendar')
        {
            showModalCalendar();
        }
        else
        {
            result(e.target.value);
            setVal(e.target.value);
        }
    }

    const resultModalCalendar = (value) => {
        if( value[0] )
        {
            let exist = opt.filter( opt => opt.value === value[1] );
            if(exist.length < 1)
            {
                let label = value[1].replace('T', ' ');
                setOpt([...opt, {value: value[1], label: label}]);
                setUpdate(!update);
            }
            
            result(value[1]);
            setVal(value[1]);
        }
    }

    useEffect( () => {
        setOptList( 
            opt.map((item, index) => (
                <option key={index} value={item.value}>{item.label}</option>
            ))
        );
    }, [update, opt])

    return (
        <>
            <CalendarSeletor result={resultModalCalendar} calendarLabel={label} show={modalCalendar} handleClose={closeModalCalendar}></CalendarSeletor>
            <select className="form-select form-select-sm" onChange={onChangeSelector} value={val}>
                {optList}
            </select>
        </>
    )
}

export const InputAuto = ({pholder, data, selectedVal, setSelectedVal, lenMax}) => {

    const inputRef = useRef(null);
    const [hasText, setHasText] = useState(false);
    const [options, setOptions] = useState(data);
    const [hasOptions, setHasOptions] = useState(false);
    const [cursorIndex, setCursorIndex] = useState(0);
    const dropdownRef = useRef();

    useEffect(() => {

        //     if( !lenMax )
        //     {
        //         inputRef.current.maxLength = "65535";
        //     }
        //     else
        //     {
        //         inputRef.current.maxLength = lenMax;
        //     }

        if (selectedVal === "")
        {
            setOptions(data);
            setHasText(false);
            setHasOptions(false);
        }
        else
        {
            setHasText(true);
        }

        if (dropdownRef.current)
        {
            const childrenArr = [...dropdownRef.current.children];
            childrenArr.forEach((el, idx) =>
            {
                if (cursorIndex === -1)
                {
                    el.classList.remove("hover");
                }
                else if (idx === cursorIndex % childrenArr.length)
                {
                    el.classList.add("hover");
                }
                else
                {
                    el.classList.remove("hover");
                }
            });
        }
    }, [selectedVal, cursorIndex]);

    const filterOptions = (text) =>
    {
        // 입력된 text로 시작하는 항목들 필터링
        const filteredOptions = data
            .filter((el) => el.toLowerCase().startsWith(text.toLowerCase()))
            .sort((a, b) => {
                // 1. 정확히 일치하는 항목 우선
                if (a === text) return -1;
                if (b === text) return 1;

                // 2. 알파벳 순서로 먼저 비교
                const compareResult = a.toLowerCase().localeCompare(b.toLowerCase());
                if (compareResult !== 0) return compareResult;

                // 3. 같은 문자일 경우 대문자 우선
                if (a !== b) {
                    if (a === a.toUpperCase()) return -1;
                    if (b === b.toUpperCase()) return 1;
                }

                return 0;
            });

        setHasOptions(filteredOptions.length !== 0);
        setOptions(filteredOptions);
    };
    
    const handleInputChange = (event) =>
    {
        const { value } = event.target;
        setSelectedVal(value)
    
        if (value.trim().length !== 0)
        {
          setHasText(true);
          filterOptions(value);
        }
        else
        {
          setHasText(false);
          setHasOptions(false);
          setSelectedVal(value);
        }
    };

    const handleDropDownClick = (clickedOption) =>
    {
        setSelectedVal(clickedOption);
        filterOptions(clickedOption);
        setHasOptions(false);
    };
    
    const keyDownHandler = (e) =>
    {
        if (e.key === "ArrowDown")
        {
            e.preventDefault();
            setCursorIndex((prev) => prev + 1);
        }
        else if (e.key === "ArrowUp")
        {
            e.preventDefault();
            setCursorIndex((prev) => Math.abs(prev - 1));
        }
        else if (e.key === "Enter")
        {
            const childrenArr = dropdownRef.current?.children || [];
            const selectedOption = childrenArr[cursorIndex % childrenArr.length]?.textContent;
        
            if (options.includes(selectedOption))
            {
                setSelectedVal(selectedOption);
                filterOptions(selectedOption);
                setCursorIndex(-1);
                setHasOptions(false);
                
                //selected value 를 상위 함수에 전달
                setSelectedVal(selectedOption);
            }
        }
        else
        {
            setCursorIndex(-1);
        }
    };

    return (
        <div className="sugesstion-auto">
            <div className="form-control-auto">
                <input
                ref={inputRef}
                type="text"
                value={selectedVal}
                onChange={handleInputChange}
                onKeyDown={(e) => keyDownHandler(e)}
                />
            </div>
            {hasText && hasOptions && (
                <div className="suggestions" ref={dropdownRef}>
                {options.map((option, index) => (
                    <div
                    key={index}
                    onClick={() => handleDropDownClick(option)}
                    className={index === cursorIndex % options.length ? 'hover' : ''}
                    >
                    {option}
                    </div>
                ))}
                </div>
            )}
        </div>
    )
}

export const GotoMonitoring = ({siteName, edgeId, type}) => {

    const navigate = useNavigate();

    const onClick = (siteName, edgeId, type) =>
    {
        if( siteName.length < 1 )
        {
            showToast(<div>This Edge is pending status.<br/> Can't move to monitoring!</div>, 'error');
            return;
        }

        if(type === 'm-agent')
        {
            sessionStorage.setItem('pageName', 'mediaMonitoring');
        }
        else if(type === 's-agent')
        {
            sessionStorage.setItem('pageName', 'schedulerMonitoring');
        }
        else if(type === 'rm')
        {
            sessionStorage.setItem('pageName', 'transmitterMonitoring');
        }

        Promise.all( [getApiSitesSite(siteName), getApiEdgeId(edgeId)] )
        .then(( [siteData, edgeData] )=>
        {
            sessionStorage.setItem('siteInfo', JSON.stringify(siteData));
            sessionStorage.setItem('edgeInfo', JSON.stringify(edgeData));

            navigate('../sites_list');
        });
    }

    return (
        <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Go to Monitoring" onClick={ () => {onClick(siteName, edgeId, type)}}><BsDisplay></BsDisplay></Button>
    );
}

export const CheckEdgeMetric = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);

    const [time, setTime] = useState('');
    const [timeGap, setTimeGap] = useState('');
    const [show, setShow] = useState(false);
    const [noValue, setNoValue] = useState(false);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.resolve(getApiDataQuery(`push_time_seconds{id="${edgeId}"}`, nowTimestamp))
        .then( data =>
        {
            if (checkApiDataResult(data))
            {
                setShow(true);
                setNoValue(true);
            }
            else
            {
                const result = data.data?.result[0]?.value;
                
                if (!result || result.length === 0)
                {
                    setShow(true);
                    setNoValue(true);
                }
                else
                {
                    setNoValue(false);

                    let time = parseInt(result[1] * 1000);
                    let timeGap = parseInt((Math.floor(new Date().getTime()) - time) / 1000);

                    setTime(updateUTCDate(new Date(time)));
                    setTimeGap(timeGap);

                    // 시간 차이에 따른 처리
                    if (timeGap > 30)
                    {
                        setShow(true);
                    }
                    else
                    {
                        setShow(false);
                    }
                }
            }
        });

    },[update, edgeId]);

    useInterval(() =>
    {
        runUpdate();
    }, 5000);

    return (
        <>
            {show && !noValue && <div className="no-signal-title ms-2">{`No Signal ( ${time} ) +${timeGap}sec`}</div>}
            {show && noValue && <div className="no-signal-title ms-2">No Signal</div>}
        </>
    )
}

export const CommonDatePicker = ({domId, domClass, domDisable, state, setState}) => {

    return (
        <DatePicker
            className={domClass}
            id={domId}
            selected={state}
            onChange={(date) => {setState(date);}}
            timeIntervals={10}
            showTimeSelect
            disabled={domDisable}
            popperPlacement="bottom-end"
            dateFormat="yyyy/MM/dd hh:mm aa"
        />
    );
}

export const TagsInputComponent = ({tags, setTags}) => {
    const [currentInput, setCurrentInput] = useState('');

    function checkExistTag(tag) {
        if (tags.length > tag.length) {
            setTags(tag);
            return;
        }
        
        const lowerCaseTags = tags.map(t => t.toLowerCase());
        const newTag = tag[tag.length - 1].toLowerCase();
        
        if (!lowerCaseTags.includes(newTag)) {
            setTags(tag);
        } else {
            showToast('Tag already exists', 'warning');
        }
    }

    const handleChange = (newTags) => {
        checkExistTag(newTags);
    };

    const handleChangeInput = (input) => {
        // 입력이 공백, 줄바꿈, 쉼표(,) 또는 세미콜론(;)로 끝나면 태그 생성
        if (input.endsWith(' ') || input.endsWith('\n') || input.endsWith(',') || input.endsWith(';')) {
            const trimmedInput = input.trim().replace(/[;,]$/, '');
            if (trimmedInput !== '') {
                checkExistTag([...tags, trimmedInput]);
            }
            setCurrentInput('');
        } else {
            setCurrentInput(input);
        }
    };

    return (
        <TagsInput
            value={tags}
            onChange={handleChange}
            inputValue={currentInput}
            onChangeInput={handleChangeInput}
            inputProps={{
                placeholder: "Add a Email",
                onBlur: (e) => {
                    const input = e.target.value;
                    if (input && input.trim() !== '') {
                        handleChangeInput(input + ' '); // 공백 추가로 태그 생성 로직 재사용
                    }
                }
            }}
        />
    );
};

export const BadgeChange = ({show}) => {

    const [html, setHtml] = useState(null);
    
    useEffect(() => {
        if (show) {
            setHtml(<span className={`bg-success span-badge-change ${show?"":"d-none"}`}></span>);
        } else {
            setHtml(null);
        }
    }, [show]);

    return (
        <>{html}</>
    );
}

export function useBlockerWithModal(when, showModal) {
    const { navigator } = useContext(NavigationContext);
    const navigate = useNavigate();
    const lastLocation = useRef(null);

    useEffect(() => {
        if (!when) return;

        const push = navigator.push;
        navigator.push = (...args) => {
            lastLocation.current = args;
            showModal({
                onConfirm: () => {
                    push(...args);
                }
            });
        };

        return () => {
            navigator.push = push;
        };
    }, [when, showModal, navigator]);
}